import React from 'react';
import { mathFormat } from '@sg/utils/common';

export const DefaultChat = {
  icon: 'discount-chart',
  value: 'line',
  tip: 'Line chart',
  format: true,
};

// Segment options for date type
export const getOptionsSegment = (formatMessage: any) => [
  { text: formatMessage({ id: 'dbs_studios_by_year' }), value: 'year' },
  { text: formatMessage({ id: 'dbs_studios_by_month' }), value: 'month' },
];

export const RevenueTrendColums = [
  {
    header: 'Month',
    dataIndex: 'month',
    key: 'month',
    width: 100,
  },
  {
    header: 'Monthly Actual',
    dataIndex: 'actual',
    key: 'Actual',
    width: 100,
    format: mathFormat,
    render: (item: any) => <div style={{ textAlign: 'right', width: '105px', textWrap: 'nowrap' }}>{mathFormat(item?.actual)}</div>,
  },
  {
    header: 'Monthly Forecast',
    dataIndex: 'forecast',
    key: 'Forecast',
    width: 100,
    format: mathFormat,
    render: (item: any) => <div style={{ textAlign: 'right', width: '116px', textWrap: 'nowrap' }}>{mathFormat(item?.forecast)}</div>,
  },
  {
    header: 'Monthly KPI',
    dataIndex: 'kpi',
    key: 'KPI',
    width: 100,
    format: mathFormat,
    render: (item: any) => <div style={{ textAlign: 'right', width: '87px', textWrap: 'nowrap' }}>{mathFormat(item?.kpi)}</div>,
  },
];
